import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { requestElectricityReplenish } from 'store/api/cuverse-api/replenish/replenish.service';
import { IReplenishRequest } from 'store/api/cuverse-api/replenish/types/replenish-request.interface';
import {
  ElectricityReplenishResponseSchema,
  TElectricityReplenishData,
} from 'store/api/cuverse-api/replenish/types/replenish-response.interface';
import { closePopupAction } from 'store/modals-reducer/modals.reducer';
import { clearPromoCheckState } from 'store/promocode-reducer/promocode.reducer';
import { AppDispatch } from 'store/store';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError } from 'utils/notify/notify.utils';

export const fetchReplenishThunkAction = createAsyncThunk<
  TElectricityReplenishData,
  IReplenishRequest,
  { dispatch: AppDispatch }
>('replenish/fetchAndPayment', async ({ amount, coupon_id }, { dispatch }) => {
  return await requestWithZodSchema(
    () => requestElectricityReplenish({ amount, coupon_id }),
    ElectricityReplenishResponseSchema,
  )
    .then((response) => {
      void dispatch(clearPromoCheckState());
      void dispatch(closePopupAction());
      return response;
    })
    .catch((error) => {
      console.log('fetchReplenishThunkAction: ', error);
      notifyError(i18n.t('notifyMessages.replenish.replenishError'));
      throw error;
    });
});
